import { render } from "./addEditAdv.vue?vue&type=template&id=4efdeff2&scoped=true"
import script from "./addEditAdv.vue?vue&type=script&lang=js"
export * from "./addEditAdv.vue?vue&type=script&lang=js"

import "./addEditAdv.vue?vue&type=style&index=0&id=4efdeff2&scoped=true&lang=css"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efdeff2"]])

export default __exports__